class Consts {
	constructor() {
		this.TEL = '090-3304-0772';
		//this.ADDRESS = '名古屋市千種区月ケ丘２－２－５６';
		this.ADDRESS = '名古屋市千種区';
		this.EMAIL = 'info@gocam.jp';
		this.COMPANY = 'パッカーズ株式会社';
	}
}

export default Consts
